import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  public hiddenCountries$ = new BehaviorSubject([]);

  constructor(private http: HttpClient) { }

  getGeneralSettings(): Observable<any> {
    const url = environment.apiUrl + `/settings/getAllSettings`;
    const settingsResponse = this.http.get<any>(url, this.httpOptions)
    settingsResponse.subscribe((res) => this.hiddenCountries$.next(res?.hiddenRaceCountries))
    return settingsResponse;
  }

  filterRaceCountries(country) {
    return this.hiddenCountries$.getValue().includes(country)
  }
}
